import { directApiInstance } from './httpClient';
import type { VerifiedDocument } from '../utils/userAdmin';

/**
 * SAM-629 — reception marks / clears a user's verified document (samUserManagement, backend
 * PR #453). `{userId}` is the sam_core."user" id, the one the /users/:id page uses.
 * The backend validates the number (JCE check digit for a cédula) and stores only a hash of it.
 */
export interface SetVerifiedDocumentRequest {
  type: 'cedula' | 'passport';
  number: string;
  country?: 'DO';
  /** YYYY-MM-DD, only when the document shows one. An expired document is refused. */
  expires_at?: string;
  reason?: string;
}

export interface SetVerifiedDocumentResponse {
  user_id: number;
  verified_document: VerifiedDocument;
}

export interface RevokeVerifiedDocumentResponse {
  user_id: number;
  verified_document: null;
  /** false when there was nothing to clear (the call is idempotent). */
  revoked: boolean;
}

const path = (userId: string | number) => `/users/${encodeURIComponent(String(userId))}/verified-document`;

export const setVerifiedDocument = (userId: string | number, body: SetVerifiedDocumentRequest) =>
  directApiInstance<SetVerifiedDocumentResponse>({ url: path(userId), method: 'PUT', data: body }) as unknown as Promise<SetVerifiedDocumentResponse>;

export const revokeVerifiedDocument = (userId: string | number, reason?: string) =>
  directApiInstance<RevokeVerifiedDocumentResponse>({
    url: path(userId),
    method: 'DELETE',
    data: reason ? { reason } : {},
  }) as unknown as Promise<RevokeVerifiedDocumentResponse>;
